import { styled } from "@mui/material/styles";
import Skeleton from "@mui/material/Skeleton";
import type { SkeletonProps } from "@mui/material/Skeleton";
import type { PaperProps } from "@mui/material/Paper";
import Section from "./Section";

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  width: "100%",
  maxWidth: theme.spacing(70),
}));

const StyledSection = styled(Section)(({ theme }) => ({
  height: theme.spacing(52),
}));

type SectionSkeletonProps = SkeletonProps & {
  sectionProps?: PaperProps;
};

export default function SectionSkeleton({
  children,
  variant = "rounded",
  sectionProps,
  ...props
}: SectionSkeletonProps) {
  return (
    <StyledSkeleton variant={variant} {...props}>
      <StyledSection {...sectionProps}>{children}</StyledSection>
    </StyledSkeleton>
  );
}
